import { useEffect, useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field, inputCls } from "@/components/LegsEditor";
import { BACKEND_URL } from "@/lib/api";
import { money } from "@/lib/format";

export default function AcceptDialog({ open, onOpenChange, token, item, index, indexes, defaultName, onAccepted }) {
  const [form, setForm] = useState({ name: "", contact: "", note: "" });
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setForm({ name: defaultName || "", contact: "", note: "" });
      setError("");
    }
  }, [open, defaultName]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await axios.post(`${BACKEND_URL}/api/share/${token}/accept`, { item_index: index, ...(indexes ? { item_indexes: indexes } : {}), ...form });
      onAccepted(data.accepted);
      onOpenChange(false);
    } catch (err) {
      setError(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  if (!item) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#111319] border-white/10 max-w-md" data-testid="accept-dialog">
        <DialogHeader>
          <p className="eyebrow">{indexes ? "Your combination" : `Option ${String(index + 1).padStart(2, "0")}`}</p>
          <DialogTitle className="font-serif-display text-3xl font-normal text-white">{item.aircraft_type}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-zinc-400 -mt-1">{money(item.total_price ?? item.client_price, item.currency || "USD")}. Your charter advisor will confirm availability and send booking details.</p>
        <form onSubmit={submit} className="space-y-3 mt-2">
          <Field label="Your name"><Input className={inputCls} value={form.name} onChange={set("name")} required data-testid="accept-name-input" /></Field>
          <Field label="Phone or email (optional)"><Input className={inputCls} value={form.contact} onChange={set("contact")} data-testid="accept-contact-input" /></Field>
          <Field label="Anything we should know? (optional)"><Textarea className="bg-[#0d0f14] border-white/10" value={form.note} onChange={set("note")} data-testid="accept-note-input" /></Field>
          {error && <p className="text-sm text-rose-300" data-testid="accept-error">{error}</p>}
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" className="frame-btn" onClick={() => onOpenChange(false)} data-testid="accept-cancel-btn">Cancel</button>
            <button type="submit" className="frame-btn gold" disabled={saving} data-testid="accept-submit-btn">{saving ? "Sending…" : "Confirm my choice"}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
